const messages = {
  en: {
    messages: {
      inn: 'Wrong TIN',
      bik: 'BIC code (MFO) contains 9 digits',
      kpp: 'IEC code (recipient code) consists of 9 digits',
      ogrn: 'Wrong FCC for Legal',
      ogrnIp: 'Wrong FCC for Individual',
      correspondentAccount: 'Wrong correspondent account or BIC',
      personalAccount: 'Wrong beneficiary`s account or BIC',
      sessionEndDate: 'End session can`t be later then start session',
      sessionEndTime: 'End session date can`t be earlier then 16:00 MSK',
      sessionEndTimeMax: 'End session date with prolongation can`t be earlier then 16:00 MSK',
      sessionEndTimeWithProlongation: 'End session date with prolongation can`t be earlier then 16:00 MSK',
      sessionStartTime: 'Start session date can`t be earlier then 10:00 MSK',
      sessionStartTimeMin: 'End session date can`t be earlier then 10:00 MSK',
      sessionStartTimeMax: 'Start session date can`t be later then 15:00 MSK',
      sessionDuration: 'Session duration can`t be earlier then 10 minutes'
    }
  },
  ru: {
    messages: {
      inn: 'Недопустимый ИНН',
      bik: 'БИК может состоять только из 9 цифр',
      kpp: 'КПП может состоять только из 9 знаков',
      ogrn: 'Недопустимый ОГРН для ЮЛ',
      ogrnIp: 'Недопустимый ОГРН для ИП',
      personalAccount: 'Неправильный расчетный счет или БИК',
      correspondentAccount: 'Неправильный корреспондентский счет или БИК',
      sessionEndDate: 'Завершение сессии не может быть ранее начала сессии',
      sessionEndTime: 'Время завершения сессии не может быть позднее 15:00 по МСК.',
      sessionEndTimeMax: 'Время завершения сессии не может быть позднее 16:00 по МСК с учетом времени продления.',
      sessionEndTimeWithProlongation: 'Время завершения продленной сессии не может быть позднее 16:00 по МСК.',
      sessionStartTime: 'Время начала сессии не может быть меньше 10:00 по МСК',
      sessionStartTimeMin: 'Время начала сессии не может быть ранее 10:00 по МСК',
      sessionStartTimeMax: 'Время начала сессии не может быть позднее 15:00 по МСК',
      sessionDuration: 'Длительность сессии не может быть менее 10 минут'
    }
  }
}

export default messages
